module.exports = __webpack_public_path__ + "img/Lark20210204-141419.654bcc63.jpeg";